import { graphql } from 'gatsby'
import React from 'react'

import Layout from '../components/Layout'
import { PurchaseMortgageCalculatorPage } from '../components/PurchaseMortgageCalculatorPage'

const PurchaseMortgageCalculatorPageTemplate = ({ data }: any) => {
  const { frontmatter } = data.markdownRemark

  return (
    <Layout title={`${frontmatter.pageTitle}`} description={frontmatter.pageDescription}>
      <PurchaseMortgageCalculatorPage {...frontmatter} />
    </Layout>
  )
}

export default PurchaseMortgageCalculatorPageTemplate

export const pageQuery = graphql`
  query PurchaseMortgageCalculatorPageTemplate {
    markdownRemark(frontmatter: { templateKey: { eq: "purchase-mortgage-calculator-page" } }) {
      frontmatter {
        pageTitle
        pageDescription
        heading
        subheading
      }
    }
  }
`
